import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Button, Loading, ReduxFormHiddenInput } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalEduDelete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onDeleteEdu, onToggleModal, selectEditEduNo, eduSummaryByEduNo } = this.props;

    if (!selectEditEduNo || !eduSummaryByEduNo.get(String(selectEditEduNo))) {
      return null;
    }

    const data = eduSummaryByEduNo.get(String(selectEditEduNo));

    const eduDeleteComponent = (
      <List bulleted className={cx('template-detail-list')}>
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>No</div>
          {data.get('eduNo')}
        </List.Item>
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>
            {defineMessages(formatMessage({ id: 'Edu_1', defaultMessage: '교육명' }))}
          </div>
          {data.get('eduName')}
        </List.Item>
        {/* <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>
            {defineMessages(formatMessage({ id: 'Edu_5', defaultMessage: '교육대상' }))}
          </div>
          {data.get('eduCount')}명
        </List.Item>
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>
            {defineMessages(formatMessage({ id: 'Edu_10', defaultMessage: '연결훈련' }))}
          </div>
          {data.get('examCount')}개
        </List.Item> */}
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>
            {defineMessages(formatMessage({ id: 'Edu_2', defaultMessage: '교육기간' }))}
          </div>
          {common.timeFormatFromUTCEpoch(data.get('startEpoch'), 3)} ~{' '}
          {common.timeFormatFromUTCEpoch(data.get('endEpoch'), 3)}
        </List.Item>
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>등록일시</div>
          {common.timeFormatFromUTCEpoch(data.get('regEpoch'))}
        </List.Item>
      </List>
    );

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagDelete-area', 'common-content')}
        visible={visible}
        header={defineMessages(formatMessage({ id: 'EduDelete_1', defaultMessage: '교육 삭제' }))}
        onToggleModal={onToggleModal}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalDeclare_1', defaultMessage: '취 소' }))}
            </Button>
            <Button
              className={cx('gray-button')}
              disabled={isClicked}
              loading={isClicked}
              onClick={e => {
                //e.stopPropagation();
                onDeleteEdu(selectEditEduNo);
              }}>
              {defineMessages(formatMessage({ id: 'ModalDeclare_2', defaultMessage: '삭 제' }))}
            </Button>
          </div>
        }>
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ModalEduDelete_1',
              defaultMessage: '삭제한 교육 정보는 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ModalEduDelete_2',
              defaultMessage: '다음 정보를 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>{eduDeleteComponent}</div>
        </Message>
      </ModalTemplate>
    );
  }
}
ModalEduDelete.propTypes = {
  visible: PropTypes.bool,
  onDeleteExam: PropTypes.func,
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      // examNo: props.selectedExam.get('examNo'),
      // examName: props.selectedExam.get('examName')
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formExamDelete', enableReinitialize: true })(injectIntl(ModalEduDelete))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalEduDelete.js